export enum LoaderType {
  STATS = "stats",
  INSIGHTS = "insights",
  RECOMMENDED_CANDIDATE = "recommended-candidate",
}
